export const FIRESTORE_KEYS = Object.freeze({
  SCHOOL_ADMINS: 'school-admins',
  SCHOOLS: 'schools',
  CLASSES: 'classes',
  TEACHERS: 'teachers',
  PARENTS: 'parents',
  EVENTS: 'events',
  SUPPORT_TICKETS: 'support-tickets',
  MAIL: 'mail',
  CONVERSATION: 'conversations',
  MESSAGES: 'messages',
});

export const FIRESTORE_FIELDS = {
  ASC: 'asc',
  CLASS_ID: 'classId',
  CONVERSATION: {
    LAST_MESSAGE: 'lastMessage',
    IS_READ_BY_TEACHER: 'isReadByTeacher',
    IS_READ_BY_PARENT: 'isReadByParent',
  },
  DESC: 'desc',
  META: { CREATED: 'meta.createdDate', MODIFIED: 'meta.modifiedDate' },
  SCHOOL:{
    ID:'school.id'
  }
};

export const toastSeverity = Object.freeze({
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
});

export const firebaseErrorCodes = Object.freeze({
  EMAIL_IN_USER: 'auth/email-already-in-use',
});

export const SCHOOL_LIST_COLUMNS = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
  },
  {
    id: 'address',
    label: 'Address',
    align: 'left',
  },
];

export const CLASS_LIST_COLUMNS = [
  {
    id: 'details.name',
    label: 'Name',
    align: 'left',
  },
  {
    id: 'school.name',
    label: 'School',
    align: 'left',
  },
  {
    id: 'teacher.name',
    label: 'Teacher',
    align: 'left',
  },
  {
    id: 'details.numberOfStudents',
    label: 'Number of Students',
    align: 'left',
  },
  {
    id: '',
    label: 'Edit',
    align: 'center',
  },
];

export const PARENT_LIST_COLUMNS = [
  {
    id: 'details.firstName',
    label: 'Name',
    align: 'left',
  },
  {
    id: 'contact.emailAddress',
    label: 'Email Address',
    align: 'left',
  },
  { id: 'students.name', label: 'Students', align: 'left' },
  {
    id: 'schools.name',
    label: 'Schools',
    align: 'left',
  },
  {
    id: 'classes.name',
    label: 'Classes',
    align: 'left',
  },
];

export const SCHOOL_CLASS_LIST_COLUMNS = [
  {
    id: 'details.name',
    label: 'Class Name',
    align: 'left',
  },
  {
    id: 'teacher.name',
    label: 'Teacher Name',
    align: 'left',
  },
  { id: 'teacher.emailAddress', label: 'Teacher Email Address', align: 'left' },
  { id: 'details.numberOfStudents', label: 'Number of Students', align: 'left' },
];

export const CLASS_PARENT_LIST_COLUMNS = [
  { id: 'details.firstName', label: 'Name', align: 'left' },
  { id: 'contact.emailAddress', label: 'Email Address', align: 'left' },
  { id: 'students.name', label: 'Students', align: 'left' },
];
export const TEACHER_LIST_COLUMNS = [
  { id: 'details.name', label: 'Name', align: 'left' },
  { id: 'contact.emailAddress', label: 'Email Address', align: 'left' },
];
export const EVENT_LIST_COLUMNS = [
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'class', label: 'Class', align: 'left' },
  { id: 'type', label: 'Type', align: 'left' },
  { id: 'date', label: 'Date', align: 'left' },
  { id: 'starts', label: 'Starts', align: 'left' },
  { id: 'ends', label: 'Ends', align: 'left' },
  { id: 'edit', label: 'Edit', align: 'right' },
];

export const TABLE_ROW_PAGINATION = [10, 25, 50, { label: 'All', value: -1 }];

export const MESSAGE_TABS = {
  ALL: 'All',
  CLASS:'Class',
  PARENT: 'Parent',
  TEACHER: 'Teacher',
  UNREAD: 'Unread',
};
